import React, { useState } from "react";
import { Box, Typography, Button, Paper, TextField } from "@mui/material";
import { useLocation } from "react-router-dom";
import axios from "axios";

const PaymentSummary: React.FC = () => {
  const location = useLocation();
  const { accountNo, amount: initialAmount } = location.state || {
    accountNo: "",
    amount: "100.00",
  };

  const [amount, setAmount] = useState(Number(initialAmount));

  return (
    <form action="https://billpay.slt.lk/confirm.php" method="post">
      <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
        <Typography variant="h6" fontWeight="bold" color="#1E2A4A" mb={2}>
          Payment Summary
        </Typography>

        <Paper
          elevation={3}
          sx={{
            width: 420,
            backgroundColor: "#F8FAFF",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          <Typography
            fontWeight="bold"
            color="#1E2A4A"
            sx={{ fontSize: "16px", mb: 1 }}
          >
            Account / Phone
          </Typography>

          <Box
            sx={{
              backgroundColor: "#EAF1FF",
              p: 1.5,
              borderRadius: 2,
              mb: 2,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography fontSize={13} color="gray">
              Account Number
            </Typography>
            <Typography fontSize={13} fontWeight="bold" color="#1E2A4A">
              {accountNo}
            </Typography>
          </Box>

          <Box
            sx={{
              backgroundColor: "#EAF1FF",
              p: 1.5,
              borderRadius: 2,
              mb: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography fontSize={14} color="gray">
              Total Amount
            </Typography>
            <input
              value={amount}
              name="vpc_Amount"
              onChange={(e) => setAmount(e.target.valueAsNumber)}
              type="number"
              style={{
                width: "100%",
                height: "45px",
                padding: "0 16px",
                borderRadius: "6px",
                fontSize: "16px",
              }}
            />
          </Box>
          <Box display="flex" justifyContent="center" gap={3} mt={3}>
            <img
              src="https://logos-world.net/wp-content/uploads/2020/11/American-Express-Logo-700x394.png"
              alt="American Express"
              width={80}
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
              alt="Visa"
              width={70}
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
              alt="MasterCard"
              width={70}
            />
          </Box>
        </Paper>
        <input hidden={true} name="EventSource" value={accountNo} />
        <Button
          variant="contained"
          type="submit"
          sx={{
            backgroundColor: "#4CAF50",
            color: "white",
            mt: 3,
            px: 4,
            borderRadius: "30px",
            fontWeight: "bold",
            textTransform: "none",
            fontSize: "16px",
            height: "45px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            minWidth: "200px",
          }}
        >
          Pay Now
        </Button>
      </Box>
    </form>
  );
};

export default PaymentSummary;
